// extracted by mini-css-extract-plugin
export default {"bidCompany":"header_bidCompany__wofB4"};